import { useEffect } from 'react';

import { useTempInfo } from '../../hooks';
import { resetAuth } from '../../utils/auth';
import { frozenOrLockedCredit } from '../../utils/tempInfo';
import DynamicNicelyDone from './DynamicNicelyDone';
import FrozenOrLockedCredit from './FrozenOrLockedCredit';

const AllDone = () => {
  const { info } = useTempInfo();

  const buyerFrozenOrLockedCredit = frozenOrLockedCredit(info?.data?.prequalification_errors ?? []);
  const cobuyerFrozenOrLockedCredit = frozenOrLockedCredit(
    info?.data?.cobuyer_prequalification_errors ?? [],
  );

  const creditFrozen = buyerFrozenOrLockedCredit || cobuyerFrozenOrLockedCredit;

  useEffect(() => {
    resetAuth({ resetGuid: true });
  }, []);

  if (creditFrozen) {
    return (
      <FrozenOrLockedCredit
        customerFrozenOrLockedCredit={buyerFrozenOrLockedCredit || false}
        cobuyerFrozenOrLockedCredit={cobuyerFrozenOrLockedCredit || false}
      />
    );
  }

  return <DynamicNicelyDone />;
};

export default AllDone;
